import React, { useEffect } from 'react';
import './Toast.css';
import { FaCheckCircle, FaTimes } from 'react-icons/fa';

function Toast({ message, onClose, duration = 3000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="toast-container">
      <div className="toast-content">
        <FaCheckCircle className="toast-icon" />
        <span className="toast-message">{message}</span>
        <button className="toast-close" onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>
      </div>
    </div>
  );
}

export default Toast;
